"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FileText, Clock, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Action() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="call-to-action" data-nav="light" className="relative w-full bg-background py-16 md:py-20 lg:py-24 border-t border-border">
      <div className="container mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} className="rounded-2xl border border-border bg-card p-6 sm:p-12 md:p-16 text-center shadow-sm relative overflow-hidden">
          {/* Subtle background motif */}
          <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 rounded-full bg-primary/5 blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 -ml-16 -mb-16 w-64 h-64 rounded-full bg-accent/20 blur-3xl pointer-events-none" />

          <div className="relative z-10 max-w-2xl mx-auto">
            {/* Operational badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-muted border border-border text-xs font-medium text-muted-foreground mb-6">
              <span className="inline-block size-2 rounded-full bg-primary animate-pulse" />
              <span>Request a quote.</span>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold font-default text-card-foreground tracking-tight mb-4">
              Have a question not answered here?
            </h2>

            <p className="text-base sm:text-lg text-muted-foreground font-default leading-relaxed mb-8">
              Submit a quote request or contact Fridge Fleet.
            </p>

            {/* Action Buttons Cluster */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="tel:2135218821" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-muted text-muted-foreground text-sm sm:text-base font-medium border border-border">
                <span>213-521-8821</span>
              </a>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-border text-foreground hover:bg-muted px-8 py-6 text-base font-semibold transition-[transform,background-color] active:scale-[0.98]">
                <Link to="/ContactRequestAQuotePage" className="inline-flex items-center justify-center gap-2">
                  <FileText className="size-5 shrink-0 text-muted-foreground" />
                  <span>Request a Quote</span>
                </Link>
              </Button>
            </div>

            {/* Quick reassurance highlights */}
            <div className="mt-10 pt-8 border-t border-border grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs text-muted-foreground">
              <div className="flex items-center justify-center sm:justify-start gap-2">
                <Clock className="size-4 text-primary shrink-0" />
                <span>Serving Southern California and our listed Las Vegas-area communities.</span>
              </div>
              <div className="flex items-center justify-center sm:justify-end gap-2">
                <ShieldCheck className="size-4 text-primary shrink-0" />
                <span>Trailer options include 6×8, 7×12, and 7×16 refrigerated and freezer trailers, plus a 53-foot reefer trailer with availability and requirements confirmed individually.</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}